var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre"},[_c('div',{staticClass:"pre_content"},[_c('img',{staticStyle:{"width":"200px"},attrs:{"alt":"","src":require("@/assets/image/load.gif")}}),_c('div',{staticClass:"pre_text"},[_vm._v("文件正在预处理中，请稍候……")]),_c('div',{staticClass:"pre_tips"},[_vm._v("程序正在加速处理中，请耐心等待"),_c('br'),_vm._v("很快将进入下一处理环节")])])])
}]

export { render, staticRenderFns }